import React from "react";
import SideStickyMenu$ from "@deosite/components-new/SideStickyMenu";

const SideStickyMenu = props => <SideStickyMenu$ {...props} />;

export default SideStickyMenu;
